import { useState } from "react";
import { Store } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, slugify } from "../lib/api";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";

export const CreateShopCard = ({ onCreated }) => {
  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [touched, setTouched] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/shop", { name, slug });
      toast.success("Toko berhasil dibuat");
      onCreated(data.shop);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid="create-shop-form" className="max-w-lg rounded-2xl border border-slate-200 bg-white p-6 sm:p-8 fade-up">
      <div className="grid h-11 w-11 place-items-center rounded-xl bg-slate-900 text-white"><Store className="h-5 w-5" /></div>
      <h2 className="mt-5 text-2xl font-bold tracking-tight">Buat toko affiliate kamu</h2>
      <p className="mt-1 text-sm text-slate-600">Satu langkah lagi sebelum mulai menambahkan produk.</p>
      <div className="mt-6 space-y-4">
        <div className="space-y-1.5">
          <Label>Nama toko</Label>
          <Input required value={name} data-testid="create-shop-name-input"
            onChange={(e) => { setName(e.target.value); if (!touched) setSlug(slugify(e.target.value)); }} />
        </div>
        <div className="space-y-1.5">
          <Label>Link toko publik</Label>
          <div className="flex items-center rounded-md border border-input bg-slate-50 pl-3 text-sm text-slate-500">
            <span className="whitespace-nowrap">{window.location.host}/</span>
            <Input required value={slug} data-testid="create-shop-slug-input" className="border-0 bg-transparent shadow-none focus-visible:ring-0 pl-0.5"
              onChange={(e) => { setTouched(true); setSlug(slugify(e.target.value)); }} />
          </div>
          <p className="text-xs text-amber-600">Link toko tidak bisa diubah atau dihapus setelah dibuat.</p>
        </div>
      </div>
      <Button type="submit" disabled={busy} data-testid="create-shop-submit-button" className="mt-6 w-full h-11 rounded-xl">
        {busy ? "Membuat..." : "Buat toko"}
      </Button>
    </form>
  );
};
